import axiosApi from "../axiosInstance";

export async function getFormCategoryDropDown(request) {
    try {
        request = {};
        const response = await axiosApi.post(`/FormCategory/GetFormCategoryDropdown`, request);
        return response?.data?.data;
    } catch (error) {
        console.log("Error getFormCategoryDropDown===>:", error);
        return null;
    }
};